<template>
    <section id="Home" class="home-section">
        <v-row align="center" class="home-hero">
            <v-col cols="12" md="5" class="home-copy">
                <span class="eyebrow">Girls in ICT &amp; innovation</span>
                <h1>Build boldly.<br><span>Lead the future.</span></h1>
                <p class="home-lede">Codettes helps girls and young women in Suriname learn technology, create meaningful projects, and grow into confident innovators.</p>
                <div class="home-actions">
                    <v-btn color="primary" large rounded depressed href="mailto:info@codettes.org?subject=Join Codettes">Join Codettes</v-btn>
                    <v-btn text large color="secondary" rounded @click="$vuetify.goTo('#Footer', { offset: 72 })">Support Codettes <v-icon right small>fas fa-heart</v-icon></v-btn>
                    <v-btn text large color="secondary" rounded @click="$vuetify.goTo('#Activities', { offset: 72 })">Explore programs <v-icon right small>fas fa-arrow-right</v-icon></v-btn>
                </div>
                <div class="home-proof"><v-icon color="secondary" small>fas fa-sparkles</v-icon> Learn. Create. Connect. Lead.</div>
            </v-col>
            <v-col cols="12" md="7">
                <v-card class="hero-media" elevation="8">
                    <v-carousel :continuous="false" cycle :show-arrows="true" hide-delimiter-background delimiter-icon="mdi-minus" height="430">
                        <v-carousel-item v-for="slide in slides" :key="slide.image" reverse-transition="fade-transition" transition="fade-transition">
                            <v-img class="hero-slide-image" :src="slide.image" :alt="slide.title" contain eager height="100%" @error="removeSlide(slide.image)" />
                        </v-carousel-item>
                    </v-carousel>
                    <div class="hero-caption"><strong>Technology is for everyone.</strong><span>Hands-on learning, real projects, lasting confidence.</span></div>
                </v-card>
            </v-col>
        </v-row>
        <v-row class="home-pillars" dense>
            <v-col v-for="pillar in pillars" :key="pillar.title" cols="12" sm="4">
                <div class="pillar"><v-icon color="primary">{{ pillar.icon }}</v-icon><div><strong>{{ pillar.title }}</strong><span>{{ pillar.text }}</span></div></div>
            </v-col>
        </v-row>
    </section>
</template>

<script>
    const fgcSlides = require.context(
        '@/assets/img/media',
        false,
        /^\.\/coverfgc(?:2|3)?\.(?:jpe?g|png|webp)$/i
    )
    const fgcSlideOrder = ['coverfgc', 'coverfgc2', 'coverfgc3']

    export default {
        name: "CHome",
        components: {},
        data: () => ({
            slides: [
                {
                    image: require('@/assets/img/media/cover1.jpg'),
                    title: 'Codettes community'
                },
                {
                    image: require('@/assets/img/media/cover2.jpg'),
                    title: 'Learning together'
                },
                {
                    image: require('@/assets/img/media/cover3.jpg'),
                    title: 'Making and sharing'
                },
                {
                    image: require('@/assets/img/media/cover4.jpg'),
                    title: 'Building the future'
                },
                {
                    image: require('@/assets/img/media/cover5.png'),
                    title: 'Creating with confidence'
                },
                {
                    image: require('@/assets/img/media/cover6.png'),
                    title: 'Learning through making'
                },
                {
                    image: require('@/assets/img/media/cover7.png'),
                    title: 'Technology in community'
                },
                {
                    image: require('@/assets/img/media/cover8.png'),
                    title: 'Ideas becoming projects'
                },
                {
                    image: require('@/assets/img/media/cover9.png'),
                    title: 'Building together'
                },
                {
                    image: require('@/assets/img/media/cover10.png'),
                    title: 'Young innovators'
                },
                {
                    image: require('@/assets/img/media/cover11.png'),
                    title: 'Making an impact'
                },
                {
                    image: require('@/assets/img/media/cover12.png'),
                    title: 'Sharing what we learn'
                },
                {
                    image: require('@/assets/img/media/cover13.png'),
                    title: 'The Codettes community'
                },
                ...fgcSlideOrder
                    .map(name => fgcSlides.keys().find(image => image.replace(/^\.\//, '').replace(/\.[^.]+$/, '').toLowerCase() === name))
                    .filter(Boolean)
                    .map(image => ({
                        image: fgcSlides(image),
                        title: 'Codettes in action'
                    }))
            ],
            pillars: [
                { icon: 'fas fa-laptop-code', title: 'Learn by doing', text: 'Practical skills that stick.' },
                { icon: 'fas fa-users', title: 'Find your people', text: 'A supportive tech community.' },
                { icon: 'fas fa-rocket', title: 'Make an impact', text: 'Ideas that serve Suriname.' }
            ]
        }),
        methods: {
            removeSlide(image) {
                this.slides = this.slides.filter(slide => slide.image !== image)
            }
        }
    }
</script>

<style scoped>
.home-section { padding: 42px 8px 24px; }
.home-hero { min-height: 510px; }
.home-copy { padding: 20px 8px 20px 24px; }
.eyebrow { color: #ce128a; font-size: .78rem; font-weight: 800; letter-spacing: .12em; text-transform: uppercase; }
h1 { color: #3b2056; font-size: clamp(2.6rem, 5vw, 4.7rem); line-height: 1.02; letter-spacing: -.05em; margin: 18px 0; }
h1 span { color: #ce128a; }
.home-lede { color: #5d5368; font-size: 1.16rem; line-height: 1.75; max-width: 510px; }
.home-actions { align-items: center; display: flex; flex-wrap: wrap; gap: 12px; margin: 28px 0 20px; }
.home-proof { color: #67308d; font-size: .9rem; font-weight: 700; }
.hero-media { border-radius: 28px; overflow: hidden; }
.hero-slide-image { background: #f4eff8; height: 100%; }
.hero-caption { background: #3b2056; color: white; display: flex; flex-direction: column; gap: 3px; padding: 18px 22px; }
.hero-caption span { color: #eadcf0; font-size: .88rem; }
.home-pillars { margin-top: 18px; }
.pillar { align-items: center; background: #fff; border: 1px solid #eee3f3; border-radius: 16px; display: flex; gap: 14px; min-height: 78px; padding: 14px 16px; }
.pillar strong, .pillar span { display: block; }
.pillar strong { color: #3b2056; }
.pillar span { color: #746b7d; font-size: .83rem; margin-top: 3px; }
@media (max-width: 600px) {
    .home-section { padding-left: 0; padding-right: 0; }
    .home-copy { padding-left: 8px; }
    .home-hero { min-height: 0; }
    .home-actions .v-btn { width: 100%; }
}
</style>
